import React, { useEffect } from 'react';

const Extension: React.FC = () => {
  useEffect(() => {
    document.title = 'OfferFlow | Extension';
  }, []);

  return (
    <div>
    </div>
  );
};

export default Extension;
